export default function timer(callback, interval, unit = 'min') {
  let calcTime;
  switch (unit) {
    case 'milliseconds':
      calcTime = interval;
      break;
    case 'seconds':
      calcTime = interval * 1000;
      break;
    case 'min':
      calcTime = interval * 60000;
      break;
    default:
      calcTime = interval;
  }
  var t;
  window.onload = resetTimer;
  window.onmousemove = resetTimer;
  window.onmousedown = resetTimer; // catches touchscreen presses as well
  window.ontouchstart = resetTimer; // catches touchscreen swipes as well
  window.onclick = resetTimer; // catches touchpad clicks as well
  window.onkeydown = resetTimer;
  window.addEventListener('scroll', resetTimer, true);

  function resetTimer() {
    clearTimeout(t);
    t = setTimeout(callback, calcTime);
  }
}
